import axiosInstance from '../axiosInstance';

export const getPricing = async (clientId) => {
    try {
        // Keep the /api prefix
        const response = await axiosInstance.get(`/payment/pricing/view-list/${clientId}`);
        return response.data; // Ensure this is not response.data.data
    } catch (error) {
        console.error('Error fetching pricing:', error);
        throw error;
    }
};
    

export const savePricing = async (clientId, data) => {
    try {
        const response = await axiosInstance.post(`/payment/pricing/${clientId}`, data);
        return response.data;
    } catch (error) {
        console.error('Error saving the client pricing data:' + error);
        throw error;
    }
};

export const updatePricing = async (clientId, data) => {
    try {
      const response = await axiosInstance.put(`/payment/pricing/update/${clientId}`, data);
      return response.data;
    } catch (error) {
        console.error('Error updating the price details' + error);
        throw error;
    }
};

export const getTransactionHistory = async (clientId = null) => {

    const url = clientId
          ? `/payment/transaction-history/${clientId}`
          : `/payment/transaction-history`;
    const response = await axiosInstance.get(url);

    return response.data.data;
};

export const getInvoicePreview = async (id, type) => {
    try {
        const response = await axiosInstance.get(`/payment/invoice/${id}/preview?type=${type}`, {
            responseType: 'text'
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching invoice layout preview mapping:", error);
        throw error;
    }
};

export const getWalletDetails = async () => {
    const response = await axiosInstance.get("/payment/wallet/details");
    return response.data;
};

export const getClientPayments = (page = 0, size = 10) => {
  return axiosInstance.get("/payment/client-recharge-payments", {
    params: {
      page,
      size
    }
  })
};

export const getMonthlyClientPayments = (
  month,
  year,
  page,
  size
) => {
  return axiosInstance.get("/payment/client-recharge-payments/monthly",
    {
      params: {
        month,
        year,
        page,
        size
      }
    }
  );
};

export const getDateRangeClientPayments = (
    startDate,
    endDate,
    page,
    size
 ) => {
   return axiosInstance.get(
    "/payment/client-recharge-payments/date-range",
    {
        params : {
            startDate,
            endDate,
            page,
            size
        }
    }
   );
 };

 export const getLatestRecharges = async () =>{
    const response = await axiosInstance.get("/payment/wallet/latest-recharges");
    return response.data;
 };

 export const getLatestUsed = async () => {
    const response = await axiosInstance.get("/payment/wallet/latest-used");
    return response.data;
 };